export const isStringify = (str) => {
    try {
        return JSON.parse(str);
    }
    catch (e) {
        return str;
    }
};
